<template>
  <!-- 应用容器 -->
  <div id="app">
    <nav-header v-if="$route.path !== '/'" />
    <router-view />
    <app-footer v-if="$route.path !== '/'" />
  </div>
</template>

<script>
import NavHeader from './components/NavHeader.vue';
import AppFooter from './components/AppFooter.vue';

export default {
  name: 'App',
  components: {
    NavHeader,
    AppFooter,
  },
};
</script>

<style scoped>
#app {
  width: 100%;
  min-height: 100%;
}

.main-content {
  width: 100%;
}
</style>
